import React, { useState, useContext } from "react"
import AppContext from "../../../../shared/AppContext"
import "./style.scss"

export const TabItem = ({ children }) => {
  return React.isValidElement(children) ? children : null
}

const TabContainer = ({ product, children }) => {
  const [selectedTabIndex, setSelectedTabIndex] = useState(0)
  const { trackEvent } = useContext(AppContext)

  const tabItemElements = React.Children.toArray(children).filter(Boolean)

  return (
    <div className="shared-insights-details-card">
      <div className="shared-insights-details-tab-list">
        {tabItemElements.map((child, idx) => {
          if (!child.props.label) {
            return null
          }
          return (
            <div
              key={idx}
              className={idx === selectedTabIndex ? "active" : ""}
              onClick={() => {
                trackEvent(
                  `Insights Report Page: ${child.props.label} tab click`,
                  {
                    productId: product.id,
                    productName: product.name,
                    productType: product.proprietaryDataset,
                  }
                )
                setSelectedTabIndex(idx)
              }}
            >
              {child.props.label}
            </div>
          )
        })}
      </div>
      {tabItemElements.map((child, idx) => {
        if (idx !== selectedTabIndex) return null
        return <div key={idx}>{child.props.children}</div>
      })}
    </div>
  )
}

export default TabContainer
